var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgGooglePlayMobile = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 158,
  height: 50,
  viewBox: "0 0 158 50",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 158,
  height: 50,
  rx: 12,
  fill: "#191919"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M77.0534 22.1362C74.4658 22.1362 72.3516 24.0852 72.3516 26.7638C72.3516 29.4315 74.4658 31.3914 77.0534 31.3914C79.6411 31.3914 81.7552 29.4315 81.7552 26.7638C81.7552 24.0852 79.6411 22.1362 77.0534 22.1362ZM77.0534 29.573C75.633 29.573 74.4107 28.4188 74.4107 26.7638C74.4107 25.0978 75.633 23.9545 77.0534 23.9545C78.4739 23.9545 79.6961 25.0978 79.6961 26.7638C79.6961 28.4188 78.4629 29.573 77.0534 29.573ZM66.7909 22.1362C64.2033 22.1362 62.0891 24.0852 62.0891 26.7638C62.0891 29.4315 64.2033 31.3914 66.7909 31.3914C69.3786 31.3914 71.4927 29.4315 71.4927 26.7638C71.4927 24.0852 69.3786 22.1362 66.7909 22.1362ZM66.7909 29.573C65.3705 29.573 64.1482 28.4188 64.1482 26.7638C64.1482 25.0978 65.3705 23.9545 66.7909 23.9545C68.2114 23.9545 69.4336 25.0978 69.4336 26.7638C69.4336 28.4188 68.2114 29.573 66.7909 29.573ZM54.5904 23.5626V25.5225H59.3473C59.2042 26.6222 58.8298 27.4389 58.2682 27.9942C57.5745 28.6802 56.4954 29.4315 54.6014 29.4315C51.6725 29.4315 49.3821 27.1013 49.3821 24.205C49.3821 21.3086 51.6725 18.9785 54.6014 18.9785C56.1761 18.9785 57.3322 19.5882 58.1801 20.3831L59.5785 19.0003C58.3893 17.8788 56.8147 17.0186 54.5904 17.0186C50.5823 17.0186 47.2129 20.2416 47.2129 24.2159C47.2129 28.1793 50.5823 31.4132 54.5904 31.4132C56.7597 31.4132 58.3893 30.7163 59.6666 29.3988C60.977 28.1031 61.3844 26.2738 61.3844 24.8039C61.3844 24.3465 61.3514 23.9219 61.2743 23.5734H54.5904V23.5626ZM104.482 25.087C104.097 24.0525 102.908 22.1362 100.474 22.1362C98.0629 22.1362 96.0589 24.009 96.0589 26.7638C96.0589 29.3553 98.0409 31.3914 100.706 31.3914C102.853 31.3914 104.097 30.0957 104.604 29.3444L103.007 28.2882C102.478 29.0613 101.752 29.573 100.706 29.573C99.6595 29.573 98.9108 29.0939 98.4373 28.1684L104.703 25.6096L104.482 25.087ZM98.0959 26.6331C98.0409 24.8474 99.4944 23.9328 100.54 23.9328C101.355 23.9328 102.049 24.3356 102.28 24.9127L98.0959 26.6331ZM93.0087 31.1192H95.0678V17.5085H93.0087V31.1192ZM89.6393 23.1706H89.5622C89.0997 22.6261 88.2188 22.1362 87.0957 22.1362C84.7503 22.1362 82.6031 24.1723 82.6031 26.7856C82.6031 29.377 84.7503 31.4023 87.0957 31.4023C88.2078 31.4023 89.0997 30.9123 89.5622 30.3461H89.6283V31.0103C89.6283 32.7851 88.6703 33.7324 87.1287 33.7324C85.8734 33.7324 85.0916 32.8396 84.7723 32.0883L82.9775 32.8287C83.495 34.0591 84.8604 35.5617 87.1287 35.5617C89.5402 35.5617 91.5773 34.1571 91.5773 30.7381V22.4193H89.6283V23.1706H89.6393ZM87.2719 29.573C85.8514 29.573 84.6622 28.3971 84.6622 26.7856C84.6622 25.1523 85.8514 23.9654 87.2719 23.9654C88.6703 23.9654 89.7714 25.1632 89.7714 26.7856C89.7824 28.3971 88.6813 29.573 87.2719 29.573ZM114.128 17.5085H109.206V31.1192H111.265V25.958H114.139C116.419 25.958 118.654 24.3248 118.654 21.7333C118.654 19.1418 116.397 17.5085 114.128 17.5085ZM114.172 24.0634H111.254V19.3923H114.172C115.714 19.3923 116.584 20.6553 116.584 21.7224C116.584 22.7895 115.714 24.0634 114.172 24.0634ZM126.879 22.1144C125.393 22.1144 123.851 22.7677 123.213 24.1941L125.041 24.9454C125.426 24.1941 126.153 23.9437 126.912 23.9437C127.981 23.9437 129.06 24.5752 129.071 25.6967V25.8383C128.696 25.6314 127.903 25.3156 126.923 25.3156C124.952 25.3156 122.959 26.3827 122.959 28.3753C122.959 30.1937 124.567 31.3696 126.373 31.3696C127.749 31.3696 128.52 30.7599 128.994 30.0412H129.06V31.0974H131.042V25.8818C131.053 23.4646 129.225 22.1144 126.879 22.1144ZM126.626 29.573C125.954 29.573 125.018 29.2355 125.018 28.4188C125.018 27.3735 126.186 26.9707 127.199 26.9707C128.102 26.9707 128.531 27.1667 129.071 27.428C128.916 28.6802 127.815 29.573 126.626 29.573ZM138.276 22.4084L135.92 28.31H135.854L133.409 22.4084H131.196L134.863 30.6619L132.77 35.246H134.918L140.566 22.4084H138.276ZM119.777 31.1192H121.836V17.5085H119.777V31.1192Z",
  fill: "white"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.5162 11.439C13.1975 11.7766 13.0107 12.2992 13.0107 12.9634V37.0488C13.0107 37.7239 13.1975 38.2466 13.5162 38.5732L13.5931 38.6494L27.2074 25.1694V25.0061V24.8428L13.5931 11.3628L13.5162 11.439Z",
  fill: "url(#svg-public/img/banner-mobile/googlePlayMobile.svg__paint0_linear_1526_3914)"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M31.749 29.659L27.2109 25.162V24.9987V24.8353L31.749 20.3384L31.8479 20.3928L37.2211 23.4198C38.7595 24.28 38.7595 25.6955 37.2211 26.5666L31.8479 29.5936L31.749 29.659Z",
  fill: "url(#svg-public/img/banner-mobile/googlePlayMobile.svg__paint1_linear_1526_3914)"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M31.8438 29.6044L27.2068 24.9985L13.5156 38.5656C14.0211 39.0992 14.8562 39.1645 15.8012 38.631L31.8438 29.6044Z",
  fill: "url(#svg-public/img/banner-mobile/googlePlayMobile.svg__paint2_linear_1526_3914)"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M31.845 20.4065L15.7914 11.369C14.8464 10.8354 14.0113 10.9008 13.5059 11.4343L27.208 25.0014L31.845 20.4065Z",
  fill: "url(#svg-public/img/banner-mobile/googlePlayMobile.svg__paint3_linear_1526_3914)"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M31.7459 29.4956L15.7911 38.4786C14.9011 38.9795 14.099 38.9468 13.5935 38.4895L13.5166 38.5657L13.5935 38.642C14.11 39.0993 14.9011 39.132 15.7911 38.6311L31.8448 29.5936L31.7459 29.4956Z",
  fill: "#1A1A1A"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.12,
  d: "M13.5152 38.4154C13.1965 38.0779 13.0098 37.5553 13.0098 36.8911V37.0544C13.0098 37.7295 13.1965 38.2521 13.5152 38.5787L13.5921 38.5025L13.5152 38.4154Z",
  fill: "#1A1A1A"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.12,
  d: "M37.2174 26.414L31.7344 29.4955L31.8333 29.5935L37.2065 26.5665C37.9756 26.1309 38.3602 25.5647 38.3602 24.9985C38.3053 25.5103 37.9207 26.0221 37.2174 26.414Z",
  fill: "#1A1A1A"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.25,
  d: "M15.79 11.5224L37.2168 23.5869C37.9091 23.9789 38.3047 24.4797 38.3706 25.0024C38.3706 24.4362 37.986 23.8591 37.2168 23.4344L15.79 11.37C14.2517 10.5098 12.999 11.2284 12.999 12.9706V13.1339C12.999 11.3808 14.2627 10.6622 15.79 11.5224Z",
  fill: "white"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "svg-public/img/banner-mobile/googlePlayMobile.svg__paint0_linear_1526_3914",
  x1: 25.9983,
  y1: 12.7128,
  x2: 7.72546,
  y2: 31.1527,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00A0FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.00657445,
  stopColor: "#00A1FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2601,
  stopColor: "#00BEFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5122,
  stopColor: "#00D2FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7604,
  stopColor: "#00DFFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00E3FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "svg-public/img/banner-mobile/googlePlayMobile.svg__paint1_linear_1526_3914",
  x1: 39.2257,
  y1: 25.0003,
  x2: 12.6378,
  y2: 25.0003,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFE000"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.4087,
  stopColor: "#FFBD00"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7754,
  stopColor: "#FFA500"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF9C00"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "svg-public/img/banner-mobile/googlePlayMobile.svg__paint2_linear_1526_3914",
  x1: 29.3241,
  y1: 27.4988,
  x2: 4.54471,
  y2: 52.5048,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF3A44"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C31162"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "svg-public/img/banner-mobile/googlePlayMobile.svg__paint3_linear_1526_3914",
  x1: 10.0635,
  y1: 3.41633,
  x2: 21.1286,
  y2: 14.5825,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#32A071"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.0685,
  stopColor: "#2DA771"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.4762,
  stopColor: "#15CF74"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8009,
  stopColor: "#06E775"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00F076"
})))));
export { SvgGooglePlayMobile as ReactComponent };